import { get } from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table, Button, Icon } from "semantic-ui-react";
import { Field } from "formik";

import FormikSemanticInput from "../forms/formik/FormikSemanticInput.jsx";
import FormikSemanticTextArea from "../forms/formik/FormikSemanticTextArea.jsx";
import RowActionsMenu from "../forms/tables/RowActionsMenu.jsx";
import FormikSemanticDropdown from "../forms/formik/FormikSemanticDropdown.jsx";

import { ROW_STATE } from "../forms/formConstants.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class SSHRow extends Component {
  static propTypes = {
    mode: PropTypes.string.isRequired,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onRemove: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    showIsUsed: PropTypes.bool.isRequired,
    formikProps: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    apiErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    showInUse: false,
    copyKey: "ssh_keys"
  };

  // -- HANDLERS -- //

  editRow = () => {
    const { id, onEdit } = this.props;
    if (onEdit) onEdit(id);
  };

  deleteRow = () => {
    const { id, onDelete } = this.props;
    if (onDelete) onDelete(id);
  };

  removeRow = () => {
    const { id, onRemove } = this.props;
    onRemove(id);
  };

  resetRow = () => {
    const { id, onReset } = this.props;
    onReset(id);
  };

  // -- RENDER -- //

  renderControls = () => {
    const { mode, onEdit, onDelete, disabled, readOnly, copy } = this.props;

    // const onEditFunc = onEdit ? this.editRow : null; // may be able to edit in future
    const onDeleteFunc = onDelete ? this.deleteRow : null;

    // if this is a new connection add a remove row button
    // if this is an existing connection show an dropdown of options
    if (mode === ROW_STATE.NEW || mode === ROW_STATE.APPLY_EXISTING) {
      return (
        <Button
          onClick={this.removeRow}
          icon="minus circle"
          size="small"
          floated="right"
          type="button"
          disabled={disabled || readOnly}
        />
      );
      // will have to change if edit is introduced
    } else {
      return (
        <RowActionsMenu
          // onEdit={onEditFunc} // may be able to edit in future
          onDelete={onDeleteFunc}
          onReset={this.resetRow}
          deleting={mode === ROW_STATE.DELETE}
          editing={mode === ROW_STATE.EDIT}
          disabled={disabled || readOnly}
          copy={copy("basic_resource_actions")}
        />
      );
    }
  };

  renderDropDown = name => {
    const { options, apiErrors, copyKey, copy } = this.props;

    return (
      <Field
        name={name}
        placeholder={copy(`${copyKey}.ssh_keys_placeholder`)}
        options={options}
        required={false}
        apiErrors={apiErrors}
        component={FormikSemanticDropdown}
      />
    );
  };

  renderInput = (name, placeholder, component) => {
    const { mode, readOnly, disabled, apiErrors, formikProps } = this.props;

    const value = get(formikProps, `values.${name}`, "");

    if (mode === ROW_STATE.EDIT || mode === ROW_STATE.NEW) {
      return (
        <Field
          name={name}
          placeholder={placeholder}
          required={true}
          readOnly={readOnly}
          disabled={disabled}
          apiErrors={apiErrors}
          component={component}
        />
      );
    } else {
      return <span>{value}</span>;
    }
  };

  renderCellOne = () => {
    const { id, mode, copyKey, copy } = this.props;

    if (mode === ROW_STATE.APPLY_EXISTING) {
      return this.renderDropDown(`${id}.@id`);
    }

    return this.renderInput(
      `${id}.name`,
      copy(`${copyKey}.name_placeholder`),
      FormikSemanticInput
    );
  };

  render() {
    const { id, formikProps, mode, showIsUsed, copyKey, copy } = this.props;

    const isUsed = get(formikProps, `values.${id}.isUsed`, false);

    return (
      <Table.Row
        key={id}
        textAlign="left"
        verticalAlign="top"
        negative={mode === ROW_STATE.DELETE}
      >
        <Table.Cell>{this.renderCellOne()}</Table.Cell>
        <Table.Cell className="ssh-key-cell">
          {this.renderInput(
            `${id}.value`,
            copy(`${copyKey}.public_key_placeholder`),
            FormikSemanticTextArea
          )}
        </Table.Cell>
        {showIsUsed === true && (
          <Table.Cell textAlign="center" collapsing>
            {isUsed === true && <Icon name="linkify" color="green" />}
          </Table.Cell>
        )}
        <Table.Cell textAlign="center" collapsing>
          {isUsed !== true && this.renderControls()}
        </Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SSHRow);
